<template>
  <div>
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M23.5 11C23.5 9.8954 22.6046 9 21.5 9H15.18L16.14 4.43C16.1604 4.3246 16.1704 4.2174 16.17 4.11C16.1691 3.7124 16.0109 3.3313 15.73 3.05L14.67 2L8.09 8.58C7.712 8.9558 7.4996 9.467 7.5 10V20C7.5 21.1046 8.3954 22 9.5 22H18.5C19.3036 22.0028 20.0298 21.5213 20.34 20.78L23.36 13.73C23.4524 13.4977 23.4999 13.25 23.5 13V11ZM1.5 22H5.5V10H1.5V22Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiFollowUs',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>